__webpack_require__.p = "https://www.dhl.com/fragments/gcr-v1/";